import React from 'react';
import Typical from "react-typical";
import aboutImg from "../../../images/received_862700541147322.jpeg";
import './Main.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const Main = () => {
    return (  
        <div className="container py-5 my-5">
          <div className="row mt-5">
              <div className="your-info col-md-6">
                <h4>Hello There, I'M</h4>
                <h1 className="my-3">MASUM BILLA</h1>
                <p className="dynamic-typical"><Typical steps={[ "PROGRAMMER", 700, "WEB DEVELOPER", 700, "DESIGNER", 700, ]} loop={Infinity} wrapper="p" className="h3 primary-text-color font-weight-bold" /></p>
                <p className="my-4 description">I'm a passionate MERN Stake Web Developer with a passion for web application development and programming. Able to complete projects efficiently with interactive and responsive design. I enjoy turning complex problems into simple, beautiful, and intuitive designs. When I'm not on my study or coding, you'll find me reading books, or watching movies.</p>

                <div className="mt-5 social-icon">
                  <a href="https://www.linkedin.com/in/masum-billa-ba8046211/" target="_blank"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                  <a href="https://twitter.com/masum48845251" target="_blank"><FontAwesomeIcon icon={faTwitter} /></a>
                  <a href="https://github.com/irajmunshy" target="_blank"><FontAwesomeIcon icon={faGithub} /></a>
                  <a href="masumiraj0218@gmail.com" target="_blank"><FontAwesomeIcon icon={faEnvelope} /></a>
                </div>

                <div className="mt-4">
                  <a href="https://drive.google.com/file/d/1qyGXeYL0qh_J_zT1RUh--ea6MPnskVgk/view" target="_blank" className="btn custom-btn mb-2 mr-3">Resume</a>
                  <a href="https://www.linkedin.com/in/masum-billa-ba8046211/" target="_blank" className="btn custom-btn">Hire me</a>
                </div>
              </div>

              <div className="offset-md-1 col-md-5">
                <div className="about-img">
                  <img className="img-fluid" src={aboutImg} alt=""/>
                </div> 
              </div> 
          </div>
        </div>
    );
};

export default Main;